/*
 * @description:前端持久化存储配置
 * @Author: liwg
 * @Date: 2022-05-02 20:45:48
 * @LastEditors: liwg
 * @LastEditTime: 2022-05-13 15:26:20
 */
import { getEnv, isDev } from '@/utils/env'
const { VITE_SHORT_NAME } = import.meta.env
export default {
  // 是否加密
  isEncrypt: !isDev,
  encryptionParams: {
    privateKey: '28f54e703cb7a9e9cdeb3668bbcf19fe77ee1ea8ecca8586be3091a8bfc8c43a',
    publicKey:
      '04598142cdc2910eb39bfddf0fdee6fddce45ffa3d81f547ef446f6bc3c7f929a9cc571e1fc22c015e2a5eb60e227010ca138899bb8d6f9ca79c7ce965bb0fa4e7'
  },
  // 过期时间
  timeout: 60 * 60 * 24 * 7,
  //前缀
  prefixKey: `${VITE_SHORT_NAME}__${getEnv()}__`.toUpperCase()
}
